import { BROWSER_TYPES as BrowserTypes } from '../../constants';

const browserMap = {
  Firefox: BrowserTypes.Firefox,
  SamsungBrowser: BrowserTypes.SamsungBrowser,
  Opera: BrowserTypes.Opera,
  Edg: BrowserTypes.Edge,
  Chrome: BrowserTypes.Chrome,
  Safari: BrowserTypes.Safari,
  Trident: BrowserTypes.InternetExplorer
} as const;

export function detectBrowser() {
  const { userAgent } = navigator;

  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

  // Chrome on iOS
  const isChromeIOS = isIOS && /CriOS/.test(userAgent);
  if (isChromeIOS) {
    return BrowserTypes.Chrome;
  }

  // Firefox on iOS
  const isFirefoxIOS = isIOS && /FxiOS/.test(userAgent);
  if (isFirefoxIOS) {
    return BrowserTypes.Firefox;
  }

  for (const [key, value] of Object.entries(browserMap)) {
    if (userAgent.includes(key)) {
      return value;
    }
  }

  return '';
}
